import { Constants } from "./constants.model";
import * as moment from "moment-timezone";
import { FormGroup, FormControl } from "@angular/forms";
import { isNullOrEmpty } from "../utilities/misc/misc.utils";

export type FormatDateTzOptions = {
  format?: string;
  timezone?: string;
}

export type InitDateTzOptions = {
  date?: moment.Moment | string;
  startOf?: moment.unitOfTime.StartOf;
  timezone?: string;
}

export class TimezoneUtils {
  public static formatDateString(dateString: string, format: string = Constants.DATETIME_TZ_FORMAT): string {
    if (!dateString) return "";
    return moment(dateString).format(format);
  }

  public static formatMomentDate(date: moment.Moment, format: string = Constants.DATETIME_TZ_FORMAT): string {
    if (!date) return "";
    return date.format(format);
  }

  public static formatDateStringTz(dateString: string, options: FormatDateTzOptions = {}) {
    if (!dateString) return "";
    const format = options?.format || Constants.DATETIME_TZ_FORMAT;
    return options?.timezone ? moment(dateString).tz(options?.timezone).format(format) : moment(dateString).format(format);
  }

  public static convertToTz(date: string | moment.Moment, timezone?: string): moment.Moment {
    if (!date) return null;
    return timezone
      ? (typeof date === 'string') ? moment(date).tz(timezone) : (date as moment.Moment).tz(timezone)
      : moment(date);
  }

  public static convertTzToUtc(momentDate: moment.Moment): moment.Moment {
    if (!momentDate) return null;
    return momentDate.clone().utc();
  }

  public static convertTzToUtcString(momentDate: moment.Moment): string {
    if (!momentDate) return "";
    return momentDate.clone().utc().format();
  }

  public static formDateChange(newDate: moment.Moment, f: FormGroup, fieldName: string, timezone?: string): boolean {
    if (!timezone || !newDate) return false;
    const newDateWithTz = newDate.clone().tz(timezone, true);
    f.patchValue({ [fieldName]: newDateWithTz });
    return true;
  }

  public static formControlDateChange(newDate: moment.Moment, control: FormControl, timezone?: string): boolean {
    if (!timezone || !newDate) return false;
    const newDateWithTz = newDate.clone().tz(timezone, true);
    control.setValue(newDateWithTz);
    return true;
  }

  public static initDateToTz(params: InitDateTzOptions = {}) {
    const startOf: moment.unitOfTime.StartOf = params?.startOf || null;
    const date: moment.Moment = params?.date
      ? (typeof params.date === 'string') ? moment(params.date) : params.date as moment.Moment
      : moment();
    const offsetDate: moment.Moment = startOf ? date.startOf(startOf) : date;
    return params?.timezone ? offsetDate.tz(params?.timezone, true) : offsetDate;
  }

  public static changeTimeZoneWithoutShiftingDateTime(newDate: moment.Moment, timezone?: string): string {
    if (isNullOrEmpty(timezone) && !isNullOrEmpty(newDate)) return newDate.clone().utc().format();
    if (isNullOrEmpty(timezone) && isNullOrEmpty(newDate)) return null;
    return moment(newDate).tz(timezone, true).format();
  }
}